import { createFileRoute } from '@tanstack/react-router';

import StoreProductTypePage from '@/components/store/product-types/specific/Page';

export const Route = createFileRoute('/store/product-types/$id')({
	component: StoreProductTypePage,
});
